{
  "nl": {
    "worksheet": {
      "autoSave": {
        "saved": "Wijzigingen opgeslagen",
        "saveFailed": "Wijzigingen konden niet worden opgeslagen",
        "sessionExpired": "Je sessie is verlopen. Log opnieuw in om wijzigingen op te slaan.",
        "draftRestoreFailed": "Concept kon niet worden hersteld"
      },
      "submitFailed": "Inleveren mislukt. Probeer het opnieuw.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Cursus",
          "focus": "Focus definiëren",
          "knowledge": "Kennis",
          "tasks": "Taken selecteren",
          "topic": "Onderwerp",
          "verify": "Werkblad controleren"
        },
        "buttons": {
          "createProposals": "Suggesties aanmaken",
          "createWorksheet": "Werkblad maken",
          "creating": "Verwerking bezig …",
          "generateLearningObjectives": "Leerdoelen door AI laten aanmaken",
          "generateNewProposals": "Alternatieve suggesties genereren",
          "generateTextBasis": "Basistekst door AI laten aanmaken",
          "regenerateLearningObjectives": "Leerdoelen opnieuw laten aanmaken",
          "regenerateTextBasis": "Basistekst opnieuw laten aanmaken",
          "retry": "Opnieuw proberen",
          "showTextBasis": "Tekstbasis op het werkblad weergeven"
        },
        "course": {
          "grade": "Klasniveau",
          "language": "Taal",
          "school": "Schooltype",
          "subject": "Schoolvak"
        },
        "descriptions": {
          "fillInTheBlank": "Vul de invuloefening in. Gebruik de volgende termen:<br/><strong>{hints}</strong>"
        },
        "errors": {
          "generationFailed": "Het werkblad kon niet worden aangemaakt. Probeer het opnieuw."
        },
        "headers": {
          "createTitle": "Werkblad met AI-Assistentie aanmaken",
          "kinds": {
            "fill_in_the_blank_text": "Invuloefening selecteren",
            "multiple_choice": "Meerkeuzevraag selecteren",
            "single_choice": "Enkelkeuzevraag selecteren",
            "text": "Voorstel voor een korte inleiding in het onderwerp",
            "text_assignment": "Tekstopdracht selecteren",
            "text_assignment_1": "Tekstopdracht (AFB I) selecteren",
            "text_assignment_2": "Tekstopdracht (AFB II) selecteren",
            "text_assignment_3": "Tekstopdracht (AFB III) selecteren"
          },
          "sampleSolution": "Modeloplossing:",
          "title": "Werkblad met AI-Assistentie aanmaken"
        },
        "hints": {
          "creatingLearningObjectives": "AI stelt leerdoelen op",
          "creatingTextBasis": "AI stelt basistekst op",
          "error": "Er is een fout opgetreden. Helaas konden we geen suggesties voor je aanmaken.",
          "learningObjectives": "Concrete leerdoelen helpen om de context van de opdrachten nauwkeuriger te definiëren en zo passendere suggesties te krijgen.",
          "progressMessage": "Opdrachten worden aangemaakt",
          "prompt": "Tip: hoe specifieker je bent, hoe concreter de voorgestelde opdrachten worden.",
          "textBasis": "De basistekst dient om de focus van het werkblad te verscherpen."
        },
        "knowledge": {
          "subtitle": "Optioneel kun je een bron toevoegen waaruit de AI de achtergrondkennis voor het werkblad haalt."
        },
        "labels": {
          "gradeLevel": "Leeftijdsgroep selecteren",
          "languageLevel": "Taalniveau (ERK) selecteren",
          "learningObjectiveHeading": "Leerdoel voor dit werkblad",
          "learningObjectives": "Leerdoelen (optioneel)",
          "schoolType": "Schooltype selecteren",
          "subjectType": "Vak selecteren",
          "textBasis": "Op welke inhoud moet het werkblad betrekking hebben?",
          "topic": "Onderwerp of vraagstelling",
          "topicHeading": "Onderwerp of vraagstelling voor dit werkblad",
          "worksheetLanguage": "Taal selecteren"
        },
        "placeholders": {
          "learningObjectiveHeading": "Welke competenties moeten worden opgebouwd? (bijv. analyse en beoordeling van de startomstandigheden van de Weimarrepubliek).",
          "learningObjectives": "Leerdoelen invoeren...",
          "prompt": "Noem de essentiële inhoud waar de opdrachten naar moeten verwijzen. Bijvoorbeeld: Het begin van de Weimarrepubliek.",
          "textBasis": "Basistekst invoeren...",
          "topicHeading": "Welke hoofdonderwerpen moet het werkblad behandelen? (bijv. 'Het begin van de Weimarrepubliek')"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Tekstopdracht genereren met AI"
        },
        "labels": {
          "prompt": "Vereisten"
        },
        "placeholders": {
          "prompt": "Beschrijf de focus van de opdracht en geef eventueel een hoofdvraag of leerdoel aan."
        },
        "description": "Wat wil je maken?"
      },
      "aiGeneration": {
        "createWithAi": "Maken met AI",
        "dropdownLabel": "AI-opties voor genereren",
        "pending": "AI maakt inhoud...",
        "menu": {
          "newVariant": "Inhoud variëren",
          "harder": "Moeilijkere opdracht",
          "easier": "Eenvoudigere opdracht",
          "addHelp": "Aanwijzingen toevoegen",
          "simpleLanguage": "Eenvoudige taal",
          "custom": "Eigen verzoek"
        },
        "prompts": {
          "newBlock": "Maak een passend {blockType}-blok als volgende logische stap in dit werkblad.",
          "newVariant": "Maak een variant van dit blok: verander context, getallen of formulering zodat de opgave niet uit het hoofd kan worden opgelost. Leerdoel en moeilijkheidsgraad blijven hetzelfde.",
          "harder": "Maak dit blok uitdagender door meer denkwerk te vragen – niet meer werk.",
          "easier": "Maak dit blok eenvoudiger: vereenvoudig taal en structuur en verwijder overbodige informatie. Leerdoel en vaktermen blijven – leg vaktermen uit in plaats van ze te vervangen.",
          "addHelp": "Voeg nuttige aanwijzingen, tussenstappen of voorbeelden toe zonder de oplossing weg te geven.",
          "simpleLanguage": "Formuleer dit blok in eenvoudige taal. Behoud vaktermen uit het leerdoel en blok en leg ze indien nodig uit.",
          "guidance": {
            "fillInTheBlank": "Voor invultekst: vul beschrijving en invultekst in; varieer de gaten passend bij de vraag."
          }
        }
      },
      "aiContext": {
        "title": "AI-Werkbladinstellingen",
        "button": "AI-instellingen",
        "description": "Bepaal hier voor wie het werkblad is. Met deze informatie kan de AI beter taken voor je maken.",
        "sections": {
          "schoolDetails": {
            "title": "Schoolgegevens"
          },
          "backgroundKnowledge": {
            "title": "Achtergrondkennis"
          }
        },
        "labels": {
          "subjectTypes": "Schoolvak",
          "schoolTypes": "Schooltype",
          "gradeLevels": "Klasniveau",
          "locale": "Taal",
          "addBackgroundKnowledge": "Achtergrondkennis toevoegen"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Voeg achtergrondkennis uit verschillende bronnen toe, bijvoorbeeld via bestandsupload en van websites, YouTube-video's, audiobestanden of video's."
        },
        "actions": {
          "removeSource": "Bron verwijderen"
        },
        "hints": {
          "hasSources": "Bronnen aanwezig"
        },
        "sourceKinds": {
          "text": "Tekst",
          "file": "Bestand",
          "pdf": "PDF",
          "image": "Afbeelding",
          "website": "Website",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "AI-instellingen konden niet worden opgeslagen"
        },
        "sourcePicker": {
          "title": "Achtergrondkennis toevoegen",
          "subtitle": "Kies een bron en de AI extraheert daaruit de tekst als achtergrondkennis voor het werkblad."
        },
        "recent": {
          "empty": "Nog geen bronnen aanwezig. Voeg eerst achtergrondkennis toe.",
          "error": "De laatst gebruikte bronnen konden niet worden geladen."
        }
      },
      "blockTypes": {
        "Divider": "Scheidingslijn",
        "File": "Bestand",
        "FillInTheBlankText": "Gatentekst",
        "H5p": "H5P",
        "Hint": "Tip",
        "Image": "Afbeelding",
        "MultipleChoice": "Meerkeuze",
        "SingleChoice": "Enkele keuze",
        "Spacer": "Afstand",
        "PageBreak": "Pagina-einde",
        "StaticText": "Tekst",
        "Text": "Tekstantwoord",
        "Upload": "Bestand aanvragen",
        "Video": "Video",
        "ToTeachExercise": "to teach oefening"
      },
      "blockTypesV2": {
        "Upload": "Bestand aanvragen",
        "ToTeachExercise": "to teach oefening"
      },
      "inserterHints": {
        "toTeachExercise": "Nieuw: gebruik je inhoud van to teach in je fobizz werkbladen.",
        "pageBreak": "Nieuw: Focus de weergave door paginascheidingen."
      },
      "navigation": {
        "headline": "Jouw voortgang",
        "previousPage": "Terug",
        "nextPage": "Volgende pagina"
      },
      "buttons": {
        "addOption": "Optie toevoegen",
        "submit": "Inleveren",
        "confirmDelete": "Ja, verwijderen",
        "duplicate": "Dupliceren",
        "generate": "Genereren",
        "deleteResponse": "Inlevering verwijderen",
        "moveDown": "Naar beneden verplaatsen",
        "moveUp": "Naar boven verplaatsen",
        "remove": "Verwijderen",
        "removeOption": "Optie verwijderen"
      },
      "elements": "Elementen",
      "addNewBlock": "Nieuw blok toevoegen",
      "multimedia": "Multimedia",
      "layout": "Lay-out",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Feedback verwijderen",
              "message": {
                "success": "Feedback verwijderd"
              }
            },
            "submit": {
              "label": "Feedback opslaan",
              "message": {
                "error": "Feedback kon niet worden opgeslagen",
                "success": "Feedback opgeslagen"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Tekstbericht schrijven"
            }
          },
          "headline": "Individuele feedback geven"
        },
        "public": {
          "headline": "Feedback van {name} op je inzending"
        },
        "shareLinkBox": "Deel link naar inzending met feedback",
        "status": {
          "hasFeedback": "Feedback gegeven"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Dit is een voorbeeld van een invultekst met een {'{'} gat {'}'}. Er kunnen {'{'} veel/meerdere/verschillende {'}'} antwoordmogelijkheden worden opgegeven. In dit geval is 'gat' het juiste antwoord in de eerste zin. In de tweede zin zijn zowel 'veel' als 'meerdere' en 'verschillende' correct.",
        "description": "Jouw beschrijvingstekst met instructies voor de verwerking (niet de invultekst). Je kunt hier ook oplossingssuggesties voor de toewijzing aanbieden, bijvoorbeeld zo: 'Vul de invultekst aan met de volgende begrippen: <i><mark>Woord 1</mark></i>, <i><mark>Woord 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Beschrijvingstekst",
        "descriptionHint": "Gebruik de beschrijvingstekst voor verwerkingsinstructies. Je kunt hier ook oplossingssuggesties voor de toewijzing aanbieden. Bijvoorbeeld {italic}",
        "descriptionHintItalic": "\"Vul de invultekst aan met de volgende begrippen: Duitsland, deelstaat, republiek,...\"",
        "clozeLabel": "Invultekst",
        "clozeHint": "\"Voorbeeld van een invultekst met een <strong>{'{'} gat {'}'}</strong>. Er kunnen <strong>{'{'} veel/meerdere {'}'}</strong> antwoorden worden vastgelegd.\" In dit geval is 'gat' het juiste antwoord en in de tweede zin zijn zowel 'veel' als 'meerdere' correct.",
        "insertGap": "Gat invoegen"
      },
      "flash": {
        "addOptionSuccess": "Optie toegevoegd",
        "createBlockSuccess": "Blok toegevoegd",
        "createSolutionSuccess": "Oplossing toegevoegd",
        "deleteBlockSuccess": "Blok verwijderd",
        "duplicateBlockSuccess": "Blok gedupliceerd",
        "deleteOptionSuccess": "Optie verwijderd",
        "deleteSolutionSuccess": "Oplossing verwijderd",
        "moveBlockSuccess": "Blok verplaatst",
        "updateBlockSuccess": "Blok bijgewerkt",
        "updateClozeTestSuccess": "Invultekst bijgewerkt",
        "updateOptionSuccess": "Optie bijgewerkt",
        "updateSolutionSuccess": "Oplossing bijgewerkt",
        "updateWorksheetSuccess": "Werkblad bijgewerkt",
        "updateWorksheetError": "Werkblad kon niet worden bijgewerkt"
      },
      "headings": {
        "saveShareLink": "Bewaar deze link om je resultaten later gemakkelijk terug te vinden."
      },
      "hints": {
        "Divider": "Gebruik de scheidingslijn om het werkblad visueel te structureren en een gedeelte van het volgende af te bakenen.",
        "File": "Voeg hier werkmateriaal toe (bijv. een tekstbestand, een afbeelding of een pdf) dat je leerlingen moeten downloaden of bekijken. Tip: gebruik het uploadtaakblok om het bewerkte bestand direct weer van je leerlingen te verzamelen.",
        "FillInTheBlankText": "Schrijf een invultekst of een vraag met één antwoordgat. Gebruik de symbolen {'{'} en {'}'} om een gat te markeren en de mogelijke oplossingswoorden te omsluiten. Als meer dan één woord correct kan zijn, scheid de oplossingswoorden met een /. Een voorbeeldzin zou kunnen luiden: \"De leerlingen moeten {'{'}een/de{'}'} gat invullen.\" Hier is zowel 'een' als 'de' een correct antwoord. Alle antwoorden worden direct beoordeeld.",
        "H5p": "Voeg interactieve H5P-inhoud toe aan je werkblad. Upload een .h5p-bestand om interactieve oefeningen, quizzen en leerspellen te maken.",
        "Hint": "Geef je leerlingen extra tips met deze visueel gemarkeerde tekstnotitie.",
        "Image": "Voeg een afbeelding uit de afbeeldingzoeker toe of upload een eigen afbeelding om je werkblad te verrijken met visuele inhoud.",
        "MultipleChoice": "Stel een vraag en voer de antwoordmogelijkheden in. Markeer de juiste antwoorden door op de cirkel ervoor te klikken. De evaluatie toont je direct bij welke taken je leerlingen de grootste zekerheid – of de grootste herhalingsbehoefte – hebben.",
        "SingleChoice": "Stel een vraag en voer de antwoordmogelijkheden in. Markeer het juiste antwoord door op de cirkel ervoor te klikken. De evaluatie toont je direct bij welke taken je leerlingen de grootste zekerheid – of de grootste herhalingsbehoefte – hebben.",
        "Spacer": "Voeg afstanden toe aan je werkblad om de inhoud overzichtelijker te maken.",
        "PageBreak": "Gebruik de paginabreuk om het werkblad in meerdere pagina's te verdelen waartussen genavigeerd kan worden.",
        "StaticText": "Gebruik het tekstelement om je leerlingen uitleg, aanwijzingen en extra info te geven voor het maken van de opdrachten. Let op: hier kunnen je leerlingen - in tegenstelling tot bij de vraagblokken - niets digitaal invullen.",
        "Text": "Stel een werkopdracht op waarvoor je leerlingen een antwoord in een tekstveld digitaal kunnen indienen.",
        "Upload": "Formuleer een werkopdracht waarvoor je leerlingen een bestand moeten uploaden (bijv. een tekstbestand, een afbeelding of een pdf). Je kunt later alle ingediende bestanden op één plek overzichtelijk beoordelen.",
        "ToTeachExercise": "Zoek naar interactieve oefeningen van to teach en voeg ze direct toe aan je werkblad.",
        "Video": "Voeg YouTube- of Vimeo-video's in via link (bijv.: https://vimeo.com/469669139).",
        "answered": "beantwoord",
        "dragNDrop": "Tip: je kunt een bestand direct uploaden via drag & drop",
        "dropFileHere": "Sleep hier een bestand naartoe of kies een bestand",
        "dropH5pFileHere": "Sleep hier een H5P-bestand naartoe of",
        "uploadH5pFilePrompt": "Sleep hier een H5P-bestand naartoe of kies een bestand",
        "elements": "Voeg uitleg en inhoud voor je leerlingen toe en structureer je werkblad.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Alleen .h5p-bestanden zijn toegestaan",
        "h5pProcessing": "H5P-inhoud wordt verwerkt, even geduld...",
        "h5pProcessingFailed": "H5P-verwerking mislukt. Probeer het opnieuw.",
        "h5pProcessingStalled": "De verwerking van deze H5P-inhoud duurt ongewoon lang. Probeer het later opnieuw of neem contact op met de ondersteuning.",
        "h5pReloadHint": "Wordt de inhoud niet weergegeven? Pagina opnieuw laden",
        "h5pFileUploadSuccess": "H5P-bestand succesvol geüpload.",
        "h5pPreviewHint": "In de voorbeeldweergave kun je de module uitproberen.",
        "toTeachExerciseImportSuccess": "to teach oefening succesvol geïmporteerd.",
        "maxOptionsReached": "Er kunnen maximaal {max} opties worden toegevoegd.",
        "name": "Voer hier je pseudoniem of naamafkorting in.",
        "noDescriptionOrCloze": "Geen beschrijving en geen invultekst opgegeven",
        "emptyBlock": "<strong>Dit blok is leeg.</strong> Het wordt niet weergegeven in de voorbeeldweergave of in de weergave voor leerlingen.",
        "noDescriptionOrOptions": "Geen beschrijving of opties opgegeven",
        "fileUploadSuccess": "Bestand succesvol geüpload.",
        "noFile": "Geen bestand geüpload",
        "noH5pContent": "Geen H5P-inhoud geüpload",
        "h5pNotPrintable": "Deze interactieve inhoud kan niet worden afgedrukt.",
        "noHint": "Geen tip ingevoerd",
        "noImage": "Geen afbeelding geüpload",
        "noInput": "Geen opgave",
        "selectFile": "Bestand selecteren",
        "noSolution": "Geen oplossing opgegeven",
        "noText": "Geen tekst ingevoerd",
        "noVideo": "Geen video ingesloten",
        "processingH5pFile": "H5P-bestand wordt verwerkt...",
        "questions": "Maak taken met velden die je leerlingen kunnen invullen.",
        "submitSuccessful": "Hartelijk dank! Je hebt je werkblad succesvol ingeleverd.",
        "searchToTeachExercises": "to teach oefeningen zoeken...",
        "processingToTeachExercise": "to teach oefening wordt geïmporteerd en verwerkt...",
        "noToTeachExercisesFound": "Geen oefeningen gevonden",
        "noToTeachExercise": "Geen to teach oefening geselecteerd",
        "toTeachSsoNotLinked": "Je account is nog niet gekoppeld aan to teach. Koppel je account om je to teach-inhoud bij fobizz te gebruiken. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Naar to teach</a>",
        "videoError": "De ingevoerde URL is ongeldig. Voer een correct adres in of verwijder je invoer.",
        "videoExample": "Voorbeeld: https://vimeo.com/469669139"
      },
      "labels": {
        "confirmDeleteBlock": "Blok verwijderen?",
        "confirmDeleteBlockText": "Let op: als je dit blok verwijdert, worden alle eventueel daaraan gekoppelde inzendingen ook verwijderd.",
        "confirmDeleteResponse": "Inzending echt verwijderen?",
        "confirmDeleteResponseText": "Moet de inzending echt worden verwijderd?",
        "confirmSubmitIncompleteResponse": "Niet alle opdrachten zijn nog bewerkt. Wil je het werkblad toch inleveren?",
        "confirmSubmitResponse": "Wil je het werkblad nu inleveren?",
        "confirmSubmitResponseTitle": "Werkblad inleveren?",
        "confirmSubmitKeepEditing": "Verder bewerken",
        "confirmSubmitAnyway": "Ja, inleveren",
        "draft": "Concept | Concepten",
        "response": "Inzending | Inzendingen",
        "responseStatus": {
          "draft": "In bewerking",
          "submitted": "Afgerond"
        },
        "respondingAs": "Je beantwoordt dit werkblad als {pseudonym}",
        "responsesTab": "Concepten en inzendingen",
        "worksheet": "Werkblad"
      },
      "links": {
        "shareResponse": "Toegangslink kopiëren",
        "showResponseSolutionToggle": "Toon modeloplossingen",
        "taskNo": "{ index }. Opdracht"
      },
      "placeholders": {
        "FillInTheBlankText": "Voer hier de gatentekst in",
        "answerInput": "Voer hier het antwoord in",
        "clickToEdit": "Klik om te bewerken",
        "description": "Voer hier de beschrijving in",
        "hint": "Voer hier de tip in",
        "imageCaption": "Voer hier het bijschrift in",
        "optionInput": "Voer hier de optie in",
        "videoCaption": "Voer hier het videobijschrift in",
        "videoUrl": "Voer de video-URL in"
      },
      "promptAttributes": {
        "derivedLanguageSkillLevel": {
          "1": "in zeer eenvoudige taal en gemakkelijk te begrijpen formuleringen voor kinderen tussen 5 en 7 jaar",
          "2": "in eenvoudige taal en gemakkelijk te begrijpen formuleringen voor kinderen tussen 7 en 10 jaar",
          "3": "in duidelijke en begrijpelijke taal voor kinderen tussen 10 en 13 jaar",
          "4": "in begrijpelijke taal en duidelijke formuleringen voor jongeren tussen 13 en 16 jaar",
          "5": "in gepaste taal en met vakspecifieke termen en formuleringen voor jongvolwassenen vanaf 17 jaar of ouder"
        },
        "regeneration": {
          "prompt": "\n\nBELANGRIJK: Maak nieuwe, duidelijk verschillende suggesties. Herhaal geen van de volgende eerdere suggesties en herformuleer ze niet alleen een beetje.{strategyInstruction}\nEerdere suggesties:\n{previousProposals}",
          "strategyInstruction": "\nGebruik deze keer gericht deze alternatieve benadering: {strategy}",
          "strategies": {
            "everydayContext": "Gebruik een alledaagse context met concrete voorbeelden.",
            "playfulFormat": "Gebruik een speelse of raadselachtige formulering met een andere zinsstructuur.",
            "analyticalPerspective": "Gebruik een zakelijk-analytisch perspectief met andere inhoudelijke accenten.",
            "creativeScenario": "Gebruik een creatief verhaal of een nieuw scenario als uitgangspunt.",
            "compareCauseEffect": "Gebruik een vergelijkings- of oorzaak-gevolg-focus in plaats van de eerdere benadering."
          }
        },
        "systemPrompt": "Je bent een {subjectType}-docent op een {schoolType} en je kent de inhoud van het leerplan voor deze doelgroep zeer goed. Je uitvoer moet passend zijn geformuleerd voor leerlingen van de leeftijdsgroep {gradeLevel} en {derivedLanguageSkillLevel}.\n You MUST answer in JSON only. You MUST use the provided schema definition and the examples. Do not return any additional fields or text.",
        "userPrompt": {
          "fill_in_the_blank_text": "Baseer al je antwoorden op de basistekst die is gemarkeerd met drie aanhalingstekens. Basistekst: \"\"\"{textBasis}\"\"\". Maak 3 versies van een korte gatentekst met elk 5 gaten, door de inhoud van de basistekst te herformuleren. Elk van de 5 gaten moet worden weergegeven met accolades en de oplossing bevatten. De tekst moet in JSON-formaat worden uitgevoerd en qua formaat aan dit voorbeeld zijn aangepast: ",
          "learning_objectives": "Je bent een expert in pedagogische en vakinhoudelijke doelstellingen en in het formuleren van opdrachten in het vak {subjectType}, gespecialiseerd in de taxonomie van Bloom. Jouw missie: Formuleer leerdoelen voor een lesuur voor de klas {gradeLevel} over het lesonderwerp '{prompt}'. Differentieer de leerdoelen zodat ze de niveaus 1-2, 3-4 en 5 van de taxonomie bestrijken en formuleer 2 leerdoelen per niveau. Gebruik eenvoudige hoofdzinnen.",
          "single_choice": "Baseer al je antwoorden op de basistekst die is gemarkeerd met drie aanhalingstekens. Basistekst: \"\"\"{textBasis}\"\"\". Schrijf een quiz met 3 vragen en 3 antwoorden inclusief oplossing. Er mag maar één antwoord juist zijn. Formuleer de opdrachten altijd in de je-vorm. De tekst moet in JSON-formaat worden uitgevoerd en qua formaat op dit voorbeeld lijken: ",
          "text_assignment": "Baseer al je antwoorden op de basistekst die is gemarkeerd met drie aanhalingstekens. Maak 3 uitgebreide tekstopdrachten die inhoudelijk betrekking hebben op de basistekst, elk met een modeloplossing die uit ongeveer {\n          count\n        } woorden bestaat. De opdrachten voldoen aan het vereiste niveau {\n          name\n        } met de definitie: '{\n          description\n        }'. Basistekst: \"\"\"{textBasis}\"\"\".\n        Formuleer de opdrachten altijd in de je-vorm. Stel geen W-vragen met de vraagwoorden Wie?, Wat?, Wanneer?, Waar?, Waarom?, Hoe?, Waartoe?, maar kies voor elk van de opdrachten een van de volgende operatoren en gebruik deze in de imperatief: {operators}. De tekst moet in JSON-formaat worden uitgevoerd en qua formaat op dit voorbeeld lijken:     ",
          "text_basis": "Schrijf een informatieve tekst als basis voor een werkblad, die relevante inhoud voor het Duitse leerplan in het vak {subjectType} op een duidelijke manier weergeeft en uitlegt. De tekst mag uitsluitend informatie bevatten en moet bijdragen aan het bereiken van de volgende leerdoelen: '{learningObjectives}'. Het onderwerp van de tekst is '{prompt}'. Geef alleen de gevraagde inhoud weer en vermijd inleidende en afsluitende opmerkingen om het antwoord te kaderen. De tekst moet bestaan uit een enkele alinea van 100 tot 500 woorden en mag geen speciale tekens, geen controletekens en geen regeleinden bevatten. De tekst moet in JSON-formaat worden uitgevoerd en qua datastructuur op het volgende codevoorbeeld lijken: "
        }
      },
      "questions": "Vragen",
      "solution": {
        "actions": {
          "add": "Modeloplossing toevoegen",
          "delete": "Modeloplossing verwijderen",
          "showResponseSolution": "Alle oplossingen na inzending tonen"
        },
        "hints": {
          "showResponseSolution": "Je leerlingen zien de opgeslagen modeloplossingen direct na inzending."
        },
        "title": "Modeloplossing",
        "types": {
          "text": {
            "placeholder": "Modeloplossing hier invoeren..."
          }
        }
      },
      "words": {
        "of": "door"
      }
    }
  }
}
